/**
 * Labstep
 *
 * @module components/User/SearchSelect
 * @desc Search users
 */

import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { useActiveGroup } from 'labstep-web/hooks/activeGroup';
import { UserGroup } from 'labstep-web/models/user-group.model';
import type React from 'react';
import type { IUserSearchSelectProps } from './types';

export const UserSearchSelect: React.FC<IUserSearchSelectProps> = ({
  onChange,
  authenticatedUserEntity,
  authenticatedUserEntityStatus,
  read,
  ...rest
}) => {
  const { activeGroup } = useActiveGroup();
  let params: Record<string, unknown> = {};
  const searchKey = 'search_query';
  if (activeGroup) {
    params = {
      is_deleted: 'both',
      group_id: activeGroup.id,
    };
  }

  return (
    <ParamsStateContextProvider value={{}}>
      <SearchSelect
        autoFocus
        params={params}
        entityName={UserGroup.entityName}
        valueKey="id"
        labelKey="name"
        searchKey={searchKey}
        onChange={(userGroup): void => onChange(userGroup.user)}
        placeholder="Search for users"
        {...rest}
      />
    </ParamsStateContextProvider>
  );
};

export default withAuthenticatedUserEntity(UserSearchSelect);
